import { TFunction } from "i18next"
import { CapabilityRequirementType } from "schema"

export function formatMissingRequirements(
  missingRequirements: Array<{ type: string; identifier: string }>,
  t: TFunction,
): string {
  const requirements = missingRequirements.map((req) => {
    if (req.type === CapabilityRequirementType.INTEGRATION) {
      const integrationKey = `capabilities.list.requirements.integrations.${req.identifier}`
      const integrationName = t(integrationKey)
      return integrationName !== integrationKey ? integrationName : req.identifier
    }
    if (req.type === CapabilityRequirementType.CAPABILITY) {
      const capabilityKey = `capabilities.catalog.${req.identifier}.name`
      const capabilityName = t(capabilityKey)
      const displayName = capabilityName !== capabilityKey ? capabilityName : req.identifier
      return `${displayName} ${t("capabilities.list.requirements.capability")}`
    }
    return req.identifier
  })

  const prefix =
    requirements.length === 1
      ? t("capabilities.list.requirements.missingSingle")
      : t("capabilities.list.requirements.missingMultiple")
  const bulletList = requirements.map((req) => `• ${req}`).join("\n")
  return `${prefix}\n${bulletList}`
}
